import React  from "react";
import { useParams } from 'react-router-dom';
import JobRoleRequestForm from "./components/JobRoleRequestForm";
import Card from "components/card";

const EditJobRoleRequest = () => {

	const { requestId } = useParams();

	return (
	    <div>
			<Card extra={"w-full h-full p-4"}>
				<div className="mt-5 grid h-full grid-cols-1 gap-4">
					<JobRoleRequestForm recordId={requestId} mode="edit"/>
				</div>
			</Card>
	    </div>
    );
};

export default EditJobRoleRequest;